import React, { Component } from 'react';
import numeral from 'numeral';

type Props = {
  value: number,
  width: number,
  totalHeight: number,
  height: number,
  color: string,
};

export default class Shadow extends Component {

  constructor(props: Props) {
    super(props);
    this.state = {
      slope: React.createRef(),
      bar: React.createRef(),
      showValue: false,
    };
  }

  getTimeoutTime() {
    return 2 * this.props.width;
  }

  drawShadowTriangle() {
    const canvas = this.state.slope.current;
    const color = this.props.color;
    const canvasHeight = canvas.height;
    const canvasWidth = canvas.width;
    const ctx = canvas.getContext('2d');
    let currentWidth = 0;
    const timerID = setInterval(() => {
      if (currentWidth === canvasWidth) {
        clearInterval(timerID);
      }
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(0, canvasHeight);
      ctx.lineTo(currentWidth, canvasHeight);
      ctx.fillStyle = color;
      ctx.fill();
      currentWidth += 5;
    }, this.getTimeoutTime());
  }

  drawShadowRectangle() {
    const canvas = this.state.bar.current;
    const color = this.props.color;
    const canvasHeight = canvas.height;
    const canvasWidth = canvas.width;
    const ctx = canvas.getContext('2d');
    let currentWidth = 0;
    const timerID = setInterval(() => {
      if (currentWidth === canvasWidth) {
        clearInterval(timerID);
        this.setState({ showValue: true });
      }
      ctx.beginPath();
      ctx.rect(0, 0, currentWidth, canvasHeight);
      ctx.fillStyle = color;
      ctx.fill();
      currentWidth += 5;
    }, this.getTimeoutTime());
  }

  componentDidMount() {
    this.drawShadowTriangle();
    this.drawShadowRectangle();
  }

  render() {
    const slopeHeight = this.props.totalHeight - this.props.height;
    return (
      <div style={{ width: `${this.props.width}%`, position: 'relative', display: 'flex', flexDirection: 'column' }}>
        <canvas
          style={{
            width: '100%',
            height: `${slopeHeight}px`,
          }}
          ref={this.state.slope}
        />
        <canvas
          style={{
            width: '100%',
            height: `${this.props.height}px`,
          }}
          ref={this.state.bar}
        />
        {this.state.showValue && (
          <div
            style={{
              position: 'absolute',
              top: slopeHeight !== 0 ? '45%' : '0%',
              marginTop: slopeHeight !== 0 ? '0px' : '-25px',
              left: '35%',
              zIndex: '1',
            }}
          >
            {numeral(this.props.value).format('0%')}
          </div>
        )}
      </div>
    );
  }
}
